<template id="Footer">
	<div v-if="showFooter">
		<div class="foot_container">
			<div class="foot_logocontainer">
				<h3>Les Relais Carte Grise - Gigean & Sète</h3>
				<div class="logo">
      			<router-link to="/" href="#Home"><img src="../assets/logo.png"></router-link>
    			</div>
    			<h3>Diam's Auto - Gigean</h3>
				<div class="logo">
      			<a href="https://www.diamsauto.fr" target="_blank"><img src="../assets/diamsauto_blanc.png"></a>
    			</div>

    			<!-- <div>
    				<fbparam></fbparam>
    			</div> -->
    			<div class="foot_socials">
	    			<div>
	    				<a class="foot_social" href="https://www.facebook.com/relaiscartegrise/" target="_blank"> <span class="material-icons md-18 md-light">facebook</span><p>Facebook</p></a>  
	    			</div>
	    			<div>
	    				<a class="foot_social" href="https://www.instagram.com/cartegrisegigean/" target="_blank"> <span class="material-icons md-18 md-light">camera_alt</span><p>Instagram</p></a>  
	    			</div>
					<div>
	    				<a class="foot_social" href="https://g.page/relaiscartegrise?gm" target="_blank"> <span class="material-icons md-18 md-light">storefront</span><p>Google</p></a>  
	    			</div>
    			</div>
			</div>
			<div class="foot_navcontainer">
				<div class="foot_nav">
					<h3>Immatriculation</h3>
					<div v-for="item in Immatriculation" >
						<router-link class="foot_ele" :to="item.path"><span class="material-icons md-15 md-light">navigate_next</span>{{item.name}}</router-link>
					</div>
				</div>
				<div class="foot_nav">
					<h3>Conduite</h3>
					<div v-for="item in Conduite" >
						<router-link class="foot_ele" :to="item.path"><span class="material-icons md-15 md-light">navigate_next</span>{{item.name}}</router-link>
					</div>
				</div>
				<div class="foot_nav">
					<h3>Etat-civil</h3>
					<div v-for="item in Etat_civil" >
						<router-link class="foot_ele" :to="item.path"><span class="material-icons md-15 md-light">navigate_next</span>{{item.name}}</router-link>
					</div>
				</div>
				<div class="foot_nav">
					<h3>Autre</h3>
					<div>
						<router-link class="foot_ele" to="/contact"><span class="material-icons md-15 md-light">navigate_next</span>Contact</router-link>
					</div>
					<div>
						<a class="foot_ele" href="/static/Mentions legales Lesrelaiscartegrise.pdf" target="_blank"><span class="material-icons md-15 md-light">navigate_next</span>Mentions légales</a>
					</div>
					<div>
						<a class="foot_ele" href="/static/Politique confidentialite Lesrelaiscartegrise.pdf" target="_blank"><span class="material-icons md-15 md-light">navigate_next</span>Politique de confidentialité</a>
					</div>
				</div>
			</div>
		</div>
		<div class="foot_right">
			© Les Relais Carte Grise 2023 ® Site internet réalisé par <a class="edit" href="https://bmra.fr" target="_blank">BMRA Web Consulting</a> - Tous droits reservés
		</div>
  	</div>

</template>

<script>
// import fbparam from './fbparam.vue'
export default {
	// components:{fbparam},
 	name: 'Footer',
  	data () {
			return {
				navs:['Immatriculation','Conduite','Etat_civil'],
				items:[],
				Immatriculation:[],
				Conduite:[],
				Etat_civil:[],
				Autre:[],
			}
		},
		computed: {
		    showFooter () {
		      return !(
		        this.$route.path === '/go/immatriculation' &&
		        this.$route.query.pay === 'ppweb'
		      )
		    }
		},
		methods: {
		},
		created() {
        this.$router.options.routes.forEach(route => {
        	this.navs.forEach(nav => {
        		if(nav == route.name){
        			route.children.forEach(child => {
        				this[nav].push({
	        				name: child.meta.name, 
							path: route.path+'/'+child.path
	        			})
        			})
        		}
        	})
        })
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.foot_container{
		display:flex;
		justify-content:center;
		//width:80%;
		padding:20px;
		flex-wrap:wrap;
	}
	.foot_logocontainer{
		flex:1;
		display:flex;
		flex-direction:column;
		justify-content:center;
		padding:10px;
		border-radius:5px;
		border:solid 2px #dfe6e9;
	}

	.foot_logocontainer h3{
		margin:0px;
	}
	.foot_navcontainer{
		flex:3;
		display:flex;
		justify-content:space-around;
	}
	.foot_social{
		display:flex;
		flex-wrap:nowrap;
		font-size:0.7em;
		justify-content:center;
		align-items:center;

		color:#dfe6e9;
		//color:black;

		text-decoration:none;
	}
	.foot_social p{
		padding-left:5px;
		margin:2px 0px 2px 0px;
	}
	.foot_container h3{
		font-weight:500;
		text-align:center;
	}
	.foot_nav{
		font-size:0.7em;
		font-weight:400;
		padding-top:10px;
		display:flex;
		flex-direction:column;
		max-width:220px;
		padding:10px;
	}
	.foot_ele{
		display:flex;
		color:#dfe6e9;
		padding:3px;
		text-decoration:none;
	}
	.foot_right{
		padding:5px;
		text-align:right;
		font-size:0.6em;
		color:#dfe6e9;
	}
	.logo{
		padding:5px 5px 20px 5px;
		display:flex;
		justify-content:center;
	}
	.logo img{
		width:150px;
	}
	.edit{
	  	font-weight:550;
	  }

	@media all and (max-width: 800px) {
	  .logo img{width:120px;}
	  .foot_container, .foot_navcontainer{
	  	flex-direction:column;
	  	align-items:center;
	  }
	  .foot_nav{
	  	max-width:none;
	  	align-items:center;
	  }
	  .foot_ele{
	  	text-align:center;
	  }
	}
</style>







// WEBPACK FOOTER //
// src/components/Footer.vue